import React, { createContext, useContext, useEffect, useState } from "react";
import { customerApi } from "@/customer/api";

const Ctx = createContext({ user: null, loading: true, login: async () => {}, register: async () => {}, logout: () => {}, refresh: async () => {} });

export const CustomerAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("wb_customer_token");
    if (!t) { setLoading(false); return; }
    let active = true;
    customerApi.get("/customer/me")
      .then((r) => { if (active) setUser(r.data); })
      .catch(() => {
        localStorage.removeItem("wb_customer_token");
        localStorage.removeItem("wb_customer_user");
      })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const persist = (data) => {
    localStorage.setItem("wb_customer_token", data.token);
    localStorage.setItem("wb_customer_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    const { data } = await customerApi.post("/auth/login", { email, password });
    return persist(data);
  };
  const register = async (payload) => {
    const { data } = await customerApi.post("/auth/register", payload);
    return persist(data);
  };
  const refresh = async () => {
    const r = await customerApi.get("/customer/me");
    setUser(r.data);
    return r.data;
  };
  const logout = () => {
    localStorage.removeItem("wb_customer_token");
    localStorage.removeItem("wb_customer_user");
    setUser(null);
  };

  return <Ctx.Provider value={{ user, loading, login, register, logout, refresh }}>{children}</Ctx.Provider>;
};

export const useCustomerAuth = () => useContext(Ctx);
